import { Box, Tooltip } from '@mui/material';
import Decimal from 'decimal.js';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import { usd } from '../../lib/util/misc-utils';

interface Props {
  orderAmt: Decimal;
  min: Decimal;
  feeCutoffAmt: Decimal;
  deliveryFee: Decimal;
}

export default function OrderMinimumMsg({
  orderAmt,
  min,
  feeCutoffAmt,
  deliveryFee,
}: Props) {
  if (!orderAmt) return null;

  if (orderAmt.greaterThanOrEqualTo(feeCutoffAmt)) {
    return (
      <Tooltip
        placement="top"
        title={`Delivery orders over ${usd(
          feeCutoffAmt,
        )} will have the delivery fee waived.`}
      >
        <Box display="flex" width="400px" sx={{ mb: 3 }}>
          <>
            <CheckCircleIcon color="primary" />
            <span>Order is Exempt from Delivery Fee</span>
          </>
        </Box>
      </Tooltip>
    );
  } else if (orderAmt.greaterThanOrEqualTo(min)) {
    return (
      <>
        <InfoIcon color="warning" />

        <span style={{ marginLeft: '0.4rem' }}>
          Order is elgible for delivery with a{' '}
          <span style={{ fontWeight: 600 }}>{usd(deliveryFee)} </span> delivery
          fee. The fee can be waived by adding{' '}
          <span style={{ fontWeight: 600 }}>
            {usd(feeCutoffAmt.minus(orderAmt))}{' '}
          </span>
          to the order. There is no delivery fee for pickup orders.
        </span>
      </>
    );
  } else {
    return (
      <>
        <InfoIcon color="warning" />
        <span style={{ marginLeft: '0.4rem' }}>
          <span style={{ fontWeight: 600 }}>{usd(min.minus(orderAmt))} </span>
          more needed to meet order minimum for delivery orders. If placing a
          pickup order, there is no minimum.
        </span>
      </>
    );
  }
}
